module.exports = __webpack_public_path__ + "static/img/14000514.2c0988a3.png";